import React from 'react'
import { useTranslateDefaultTitle } from '../../../hooks/useTranslateDefaultTitle'

export function PreviewTitle({ value, fallback }: { value?: string; fallback: string }) {
  const title = useTranslateDefaultTitle(value || '')

  return <strong title={title || fallback}>{title || fallback}</strong>
}
